module.exports = __webpack_public_path__ + "static/media/other-service-policy.255172e2.svg";